var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"section  content is-size-7 has-text-white"},[_c('p',{staticClass:"is-size-5 has-text-primary"},[_vm._v("Zrušení")]),_vm._v(" "),_c('p',[_vm._v("\n      Poplatky za služby se automaticky obnoví, dokud zákazník nezruší odesláním STOP AAA do roku 90303. \n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2913a902","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LangKyf/FI/Deactivation.vue
// module id = null
// module chunks = 